const customerAccounts = () => {
    const customerAccount = document.querySelector('[data-customer-account]');
    if (customerAccount) {
        const selectors = {
            accordion: '[data-accordion]',
            accordionTitle: '[data-accordion-title]',
            accordionContent: '[data-accordion-content]',
            openOnLoad: 'open-on-load',
        };
        const classes = {
            accordionTitleOpen: 'accordion__title--open',
            accordionContentOpen: 'accordion__content--open',
        };
        const openAccordion = (accordion) => {
            const title = accordion.querySelector(selectors.accordionTitle);
            const content = accordion.querySelector(selectors.accordionContent);
            title.classList.add(classes.accordionTitleOpen);
            content.classList.add(classes.accordionContentOpen);
            content.style.maxHeight = content.scrollHeight + 'px';
        };
        const closeAccordion = (accordion) => {
            const title = accordion.querySelector(selectors.accordionTitle);
            const content = accordion.querySelector(selectors.accordionContent);
            title.classList.remove(classes.accordionTitleOpen);
            content.classList.remove(classes.accordionContentOpen);
            content.style.maxHeight = null;
        };
        const accordions = customerAccount.querySelectorAll(selectors.accordion);
        accordions.forEach((accordion) => {
            const title = accordion.querySelector(selectors.accordionTitle);
            const content = accordion.querySelector(selectors.accordionContent);
            if (content.hasAttribute(selectors.openOnLoad)) {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
            if (title && content) {
                title.onclick = () => {
                    if (content.style.maxHeight) {
                        closeAccordion(accordion);
                    }
                    else {
                        accordions.forEach((accordion) => closeAccordion(accordion));
                        openAccordion(accordion);
                    }
                };
            }
        });
        window.addEventListener('resize', () => {
            accordions.forEach((accordion) => {
                const content = accordion.querySelector(selectors.accordionContent);
                if (content && content.style.maxHeight) {
                    openAccordion(accordion);
                }
            });
        });
    }
};
export { customerAccounts };
